import React from 'react';
import ENV from '../../base/env';
import './TrustPilotBadge.scss';
import getExperiment, { EExperiment } from './utils';

export default function TrustPilotBadge() {
  const experiment = getExperiment();
  if (experiment === EExperiment.None) {
    return null;
  }
  const badgeSrc = `${ENV.AssetsBaseUrl}/feature/trustpilot-badge.png`;
  return (
    <div className="trustpilot-badge">
      <a href="https://www.trustpilot.com/review/neuronation.com" target="_blank" rel="noopener noreferrer">
        <img data-testid="badge-img" src={badgeSrc} alt="TrustPilot rating" />
      </a>
    </div>
  );
}
